import { useSelector } from "@nf/common";

export const usePaymentDetails = () => {
  const {
    currentOffer,
    paymentDetails: {
      Data: paymentDetails,
      IsProcessing: isPaymentDetailsLoading,
    },
    payment: {
      Data: payment,
      IsProcessing: isPaymentLoading,
      Error: paymentError,
    },
  } = useSelector((state) => state.payment);
  const {
    Data: subscriptions,
    IsProcessing: isSubscriptionLoading,
    Error: subscriptionError,
  } = useSelector((state) => state.user.subscriptions);

  return {
    currentOffer,
    paymentDetails,
    isPaymentDetailsLoading,
    payment,
    isPaymentLoading,
    paymentError,
    subscriptions,
    isSubscriptionLoading,
    subscriptionError,
  };
};
